import React, {useState} from 'react'
import Card from '@components/V3/Card'
import Pill from '@components/V3/Pill'
import Text from '@components/V3/Text'
import TextSkeleton from '@components/V3/Text/TextSkeleton'
import BigDivider from '@page-components/TrackV2/components/BigDivider'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

import Details from './Details'

export const OrderSkeleton = () => {
  return (
    <Card transparentOnDesktop desktopThreshold="lg">
      <div className="flex items-center px-4">
        <div className="flex-1">
          <TextSkeleton type="caption" className="w-1/4" />
          <TextSkeleton type="title" className="w-2/5" />
        </div>
      </div>
    </Card>
  )
}

export default function Order() {
  const {order} = useOrder()
  const {t} = useTranslation('tracking')
  const [showDetails, setShowDetails] = useState(false)
  return (
    <Card transparentOnDesktop desktopThreshold="lg">
      <BigDivider className="hidden lg:block" />
      <div className="flex items-center px-4">
        <div className="flex-1">
          <Text type="caption">{t('order.caption')}</Text>
          <Text id={'order-number'} type="title">
            {order.fullCode}
          </Text>
        </div>
        <Pill
          small
          caretDirection={showDetails ? 'up' : 'down'}
          onClick={() => setShowDetails(!showDetails)}>
          {t('order.details')}
        </Pill>
      </div>
      <Details showDetails={showDetails} />
    </Card>
  )
}
